module.exports = __webpack_public_path__ + "static/media/login.cbc5e615.png";